"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Week = _interopRequireDefault(require("./Week"));
var _constants = require("../../constants");
var _CardSlider = _interopRequireDefault(require("../../CardSlider/CardSlider"));
var Weeks = function Weeks(_ref) {
  var weeks = _ref.weeks,
    changeWeek = _ref.changeWeek,
    activeWeek = _ref.activeWeek;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "weekly-tabs-weeks margin-bottom-md"
  }, /*#__PURE__*/_react["default"].createElement(_CardSlider["default"], {
    type: _constants.CARD_SLIDER_TYPES.NON_FULL_WIDTH,
    parentOffset: 20,
    hideControls: true
  }, weeks.map(function (week, i) {
    return /*#__PURE__*/_react["default"].createElement(_Week["default"], {
      key: JSON.stringify(week),
      week: week,
      changeWeek: changeWeek,
      index: i,
      activeWeek: activeWeek
    });
  })));
};
Weeks.propTypes = {
  weeks: _propTypes["default"].array.isRequired,
  changeWeek: _propTypes["default"].func.isRequired,
  activeWeek: _propTypes["default"].number
};
var _default = exports["default"] = Weeks;